import React, { useState } from "react";
import { X } from "lucide-react";
import { Button } from "../ui/Button";
import FormField from "../ui/FormField";

interface SendReminderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (text: string) => void;
  title?: string;
  recipientLabel?: string;
}

export const SendReminderModal: React.FC<SendReminderModalProps> = ({
  isOpen,
  onClose,
  onSend,
  title = "Send Reminder",
}) => {
  const [text, setText] = useState("");
  const wordLimit = 500;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSend(text);
    setText("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/40 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-lg w-full max-w-lg flex flex-col mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - Matching Theme */}
        <div className="px-6 py-4 border-b border-[#885ABB] flex justify-between items-center bg-[#885ABB] rounded-t-xl">
          <h2 className="text-xl font-bold text-white flex-1">{title}</h2>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white hover:bg-white/10 p-1 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="space-y-2">
            <FormField
              label="Enter Text:"
              name="reminderText"
              type="textarea"
              value={text}
              onChange={(_, val) => setText(val)}
              className="min-h-[150px]"
              placeholder=""
            />
            <div className="flex justify-between items-center text-xs text-gray-500">
              <span>
                Words limit: {text.length}/{wordLimit}
              </span>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="border-gray-300 text-gray-700 hover:bg-gray-50 bg-white"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-[#885ABB] hover:bg-[#6f47a2] text-white"
            >
              Send
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
